import './Home.css';

// Links orbit the centre; each one starts 10s further along the orbit.
const LINKS = [
  { href: "https://x.com/cata_dioptric", logo: "X_logo.webp", name: "X(Twitter)" },
  { href: "https://bsky.app/profile/catadioptric.bsky.social", logo: "Bluesky_logo.webp", name: "Bluesky" },
  { href: "https://www.instagram.com/cata_dioptric/", logo: "Instagram_logo.webp", name: "Instagram" },
  { href: "https://picrew.me/ja/search/creator?crid=736425", logo: "Picrew_logo.webp", name: "Picrew" },
  { href: "https://www.pixiv.net/users/43284982", logo: "Pixiv_logo.webp", name: "Pixiv" },
  { href: "https://www.youtube.com/@cata_dioptric", logo: "Youtube_logo.webp", name: "Youtube" },
  { href: "https://soundcloud.com/cata_dioptric", logo: "Soundcloud_logo.webp", name: "Soundcloud" },
  { href: "https://open.spotify.com/artist/6kSMkeXq6Eznnmw0j3aGLa?si=_ZcOmnQQRv-7l0j3gY4ryg", logo: "Spotify_logo.webp", name: "Spotify" },
  { href: "https://www.postype.com/@cata-dioptric", text: "POSTYPE" },
  { href: "https://marpple.shop/kr/cata_dioptric", text: "SHOP" },
  { href: "https://tsotds.tistory.com/category", text: "BLOG" },
  { href: "mailto:tsotds101@gmail.com", text: "MAIL" },
];

// Background pieces drawn as a left/right mirrored pair.
const PAIRS = [
  { className: "wing2", src: "Background Wing 2.webp" },
  { className: "flower", src: "Background Flower.webp" },
  { className: "flower2", src: "Background Flower 2.webp" },
  { className: "flower3", src: "Background Flower 3.webp" },
];

function Home() {
  return (
    <div className="Home">
      <div id="home_background">
        <img id="odradek" src="/Odradek.webp" alt="Here's an art of my OC :)"/>

        {PAIRS.map(({ className, src }) => (
          <div className={className} key={className}>
            <img className="background_left" src={`/${src}`} alt=""/>
            <img className="background_right" src={`/${src}`} alt=""/>
          </div>
        ))}

        <div id="ribbon_container">
          <img id="ribbon" src="/Background Ribbon.webp" alt=""/>
        </div>
        <img id="ribbon2" src="/Background Ribbon 2.webp" alt=""/>
        <img id="ribbon3" src="/Background Ribbon 3.webp" alt=""/>
        <img id="ribbon_text" src="/Background Solve Coagula.webp" alt=""/>

        <div id="yin_yang_and_shantih">
          <div id="shantih">
            <p>SHANTIH SHANTIH SHANTIH SHANTIH SHANTIH SHANTIH SHANTIH SHANTIH </p>
          </div>
          <div className="yin_yang">
            <img className="background_left" src="/Background Yin Yang.webp" alt=""/>
            <img className="background_right" src="/Background Yin Yang.webp" alt=""/>
          </div>
        </div>

        <div id="background_no_overflow">
          <img id="background" src="/Background.webp" alt=""/>
          <img id="background_wing" src="/Background Wing.webp" alt=""/>
          <div className="background_dot">
            <img src="/Background Dot.webp" alt=""/>
            <img src="/Background Dot.webp" alt="" style={{transform: 'scaleX(-1)'}}/>
          </div>
        </div>
        <div id="fixed_no_overflow">
          <img id="background_pattern" src="/Background Pattern.webp" alt=""/>
        </div>

        <div id="links">
          {LINKS.map((link, i) => (
            <a key={link.href} href={link.href} target="_blank" rel="noreferrer"
              style={{animation: `orbit 120s ${i * -10}s linear infinite`}}>
              {link.logo
                ? <img src={`/${link.logo}`} alt={`Logo of ${link.name}`}/>
                : <p>{link.text}</p>}
            </a>
          ))}
        </div>
      </div>

      <div id="tail_container">
        <img id="tail" src="/Background Tail.webp" alt=""/>
      </div>
    </div>
  );
}

export default Home;
